import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import MaterialDivider from './MaterialDivider';

const DilutionForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Dilution'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Dilution Buffer Type"
            name={`dilution_buffer_type-${data?.index}`}
            value={data?.dilution_buffer_type}
            onChange={e => 
              handleInputChange(e, data?.index, 'dilution_buffer_type', e.target.value)
            }
            helperText={formErrors[`dilution_buffer_type-${data?.index}`]}
            error={`dilution_buffer_type-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Dilution Factor"
            name={`dilution_factor-${data?.index}`}
            value={data?.dilution_factor}
            onChange={e => 
              handleInputChange(e, data?.index, 'dilution_factor', e.target.value)
            }
            helperText={formErrors[`dilution_factor-${data?.index}`]}
            error={`dilution_factor-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Payload concentration after dilution"
            name={`payload_concentration_after_dilution-${data?.index}`}
            value={data?.payload_concentration_after_dilution}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'payload_concentration_after_dilution', e.target.value
              )
            }
            helperText={
              formErrors[`payload_concentration_after_dilution-${data?.index}`]
            }
            error={`payload_concentration_after_dilution-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Volume after dilution"
            name={`volume_after_dilution-${data?.index}`}
            value={data?.volume_after_dilution}
            onChange={e => 
              handleInputChange(e, data?.index, 'volume_after_dilution', e.target.value)
            }
            helperText={formErrors[`volume_after_dilution-${data?.index}`]}
            error={`volume_after_dilution-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

DilutionForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default DilutionForm;